import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { FeatureCardModule } from '@hiptraveler/ui/feature-card';

import { ItinerariesTabComponent } from './itineraries-tab.component';
import { NavigateToTripDirective } from './navigate-to-trip.directive';

const MODULES = [
  CommonModule,
  TranslateModule,
  LazyLoadImageModule,
  NgxSkeletonLoaderModule
];

const LIBRARIES = [
  FeatureCardModule
];

const COMPONENTS = [
  ItinerariesTabComponent
];

const DIRECTIVES = [
  NavigateToTripDirective
];

@NgModule({
  imports: [
    MODULES,
    LIBRARIES
  ],
  declarations: [
    COMPONENTS,
    DIRECTIVES
  ],
  exports: [
    ItinerariesTabComponent
  ]
})
export class ItinerariesTabModule { }
